import UserChatManager from './UserChatManager';

/**
 * Chat Button for Regular Users - WhatsApp style interface
 * Shows support chat with ability to distinguish between admin and agent messages
 * Uses UserChatManager for better UI/UX
 */
export default function HomeChatButton() {
  return <UserChatManager />;
}

